import { Controller } from '@hotwired/stimulus'

export default class SubscriptionSimulatorController extends Controller {
  static targets = ['frame', 'amount', 'bonusCode', 'display', 'sponsorshipAmount'];
  static values = { bonusRate: Number };

  connect() {
    this.debouncedRefresh = Helpers.debounce(() => this._refresh(), 1000);
  }

  refresh() {
    this._updateSponsorshipAmount();
    this.debouncedRefresh();
  }

  _refresh() {
    this._updateSponsorshipAmount();
    if (!this.hasFrameTarget) return;

    const url = new URL(this.frameTarget.dataset.url);

    url.searchParams.set('targeted_amount', this.amountTarget.value || 1);

    if (this.hasBonusCodeTarget) {
      url.searchParams.set('bonus_code_text', this.bonusCodeTarget.value);
    }

    this.frameTarget.src = url.toString();
  }

  _updateSponsorshipAmount() {
    if (!this.hasSponsorshipAmountTarget) return;

    const amount = parseFloat(this.amountTarget.value) || 0;
    const bonus = Math.floor(amount * this.bonusRateValue) / 100;

    this.sponsorshipAmountTarget.textContent = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(bonus);
  }

  closeOffcanvas() {
    if (this.amountTarget.value > 0) {
      bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('offcanvasBottom')).hide();
    }
  }

  closeModal() {
    const modal = this.element;
    if (modal.classList.contains('show')) {
      const modalInstance = bootstrap.Modal.getInstance(modal);
      modalInstance.hide();
    }
  }

  syncAmountToSubscriptionForm() {
    if (!this.hasAmountTarget) return;

    const formAmountInput = this._formAmountInput();
    if (!formAmountInput) return;

    const intValue = parseInt(this.amountTarget.value, 10);
    formAmountInput.value = isNaN(intValue) ? '' : intValue;
    formAmountInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  syncAmountFromSubscriptionForm() {
    if (!this.hasAmountTarget) return;

    const formAmountInput = this._formAmountInput();
    if (formAmountInput && formAmountInput.value) {
      this.amountTarget.value = formAmountInput.value;
      this.amountTarget.dispatchEvent(new Event('input', { bubbles: true }));
      this._refresh();
    } else {
      this.amountTarget.value = '';
      if (this.hasDisplayTarget) this.displayTarget.value = '';
      if (this.hasFrameTarget) {
        this.frameTarget.innerHTML = '';
        this.frameTarget.removeAttribute('src');
      }
      this._updateSponsorshipAmount();
    }

    if (!this.amountTarget.value && this.hasDisplayTarget) {
      this.displayTarget.focus();
    }
  }

  focusSubscriptionFormAmount() {
    const formAmountInput = this._formAmountInput();
    if (!formAmountInput) return;

    this.element.addEventListener('hidden.bs.modal', () => {
      formAmountInput.focus();
    }, { once: true });
  }

  _formAmountInput() {
    return document.querySelector('[data-plan-investment-target="amountInput"]');
  }
}
